export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/fast_phonics-d60a0ebfd4b96d4559c8f1d21cdef28a.svg";